import { changeSystemTheme } from '../utils/changeSystemTheme';
import { getOpxHostApi } from 'owa-opx';
import { getThemeMode } from '../selectors/getThemeMode';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { onOpxThemeChange } from './onOpxThemeChange';
import { ThemeMode } from '../schema/ThemeMode';

export const monitorSystemThemeChanges = (): void => {
    if (isHostAppFeatureEnabled('opxComponentLifecycle')) {
        getOpxHostApi().registerThemeChangedHandler(onOpxThemeChange);
        return;
    }

    window.matchMedia?.('(prefers-color-scheme: dark)')?.addEventListener('change', () => {
        const themeMode = getThemeMode();
        // Refresh only if we are dependent on browser's dark mode preference
        if (themeMode === ThemeMode.System) {
            changeSystemTheme(themeMode);
        }
    });
};
